module.exports = __webpack_public_path__ + "static/pic02-0638d6e17c1c5ef0f9bf1bad6f4a5c1c.jpg";